import { render, staticRenderFns } from "./General_Settings.vue?vue&type=template&id=1778f874&scoped=true"
import script from "./General_Settings.vue?vue&type=script&lang=js"
export * from "./General_Settings.vue?vue&type=script&lang=js"
import style0 from "./General_Settings.vue?vue&type=style&index=0&id=1778f874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1778f874",
  null
  
)

export default component.exports